<template>
    <div class="setting-wrapper">
        <div class="setting">
            <span class="h4 lg:w-1/5">
                {{ lang('Kanaler','Channels') }}
            </span>
            <div v-if="toggled" class="text-sm text-neutral-dark mb-lg md:mb-xl lg:hidden">
                <tv-channel-list :tv-package="tvPackage" />
            </div>
            <div class="w-full flex items-center w-full lg:w-4/5">
                <div class="w-full mr-auto text-sm text-neutral-darker lg:w-5/6">
                    <span class="font-bold">
                        {{ tvChannels }} {{ lang('TV-kanaler','TV Channels') }}
                    </span>
                </div>
                <a
                    :class="{ 'is-active' : toggled }"
                    class="absolute pin-t pin-r flex items-center mt-xl lg:relative lg:mt-0 text-neutral-darker read-more"
                    tabindex="0"
                    @click="toggle"
                    @keydown.enter="toggle"
                >
                    <font-awesome-icon icon="chevron-down" class="chevron text-sm lg:text-lg" />
                </a>
            </div>
        </div>
        <div v-if="toggled" class="text-sm text-neutral-dark mb-lg md:mb-xl hidden lg:block">
            <tv-channel-list
                :tv-package="tvPackage"
            />
        </div>
    </div>
</template>
<script>
    import TvChannelList from '../../Tv/Partials/TvChannelList';
    import TvChannelsMixin from '../../Tv/Partials/TvChannelsMixin';

    export default {
        components: {
            TvChannelList,
        },
        mixins: [TvChannelsMixin],
        props: {
            tvPackage: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                toggled: false,
            };
        },
        methods: {
            toggle() {
                this.toggled = ! this.toggled;
            },
        },
    };
</script>
